import { createContext } from 'react';
import { TranslateFormContext } from '../hooks/useFormTranslate';

export const FormTranslationContext = createContext({} as TranslateFormContext);
